import { Ruler } from 'lucide-react';
import { CataloguePanel } from '../../../components/CataloguePanel';
import { useContainerSizes } from '../hooks/use-container-sizes';
import { buildContainerSizeColumns } from './build-container-size-columns';
import { ContainerSizeFormDrawer } from './ContainerSizeFormDrawer';

/** The container sizes rate lines and jobs match by code (gitaumoses4/chukua#23, #355). */
export function ContainerSizesPanel() {
  const { state, saveError, saving, resetSaveError, create, update, deactivate, reactivate } = useContainerSizes();
  return (
    <CataloguePanel
      noun="container size"
      plural="container sizes"
      icon={Ruler}
      emptyDescription="Add the container sizes your rate cards and jobs use, such as 20 and 40."
      state={state}
      saveError={saveError}
      saving={saving}
      resetSaveError={resetSaveError}
      create={create}
      update={update}
      deactivate={deactivate}
      reactivate={reactivate}
      buildColumns={buildContainerSizeColumns}
      Drawer={ContainerSizeFormDrawer}
    />
  );
}
